(function () {
  // ---------- Réglages ----------
  var TEXTE_BANDEAU = 'fabrication artisanale'; // texte (en minuscules) qui identifie le bandeau des points forts
  var CACHER_TANT_QUE_BANDEAU = true;  // false = les deux boutons du haut sont toujours visibles
  var MARGE_BANDEAU = 8;               // le bandeau est "passé" quand son bas est au niveau de l'en-tête (+ cette marge, en pixels)

  // Boutons "Savoir-faire" et "Demander un échantillon" du site : déplacés en haut de l'écran
  var BOUTONS_EN_HAUT = true;
  var BOUTONS_HAUT_ECART = 16;         // distance sous l'en-tête du site, en pixels

  // Voile blanc dégradé derrière ces deux boutons
  var VOILE_HAUT = true;
  var VOILE_RGB = '255, 255, 255';
  var VOILE_OPACITE = 0.94;
  var VOILE_DEGRADE = 26;
  var VOILE_APPARITION = 120;

  // Bouton flottant "Filtrer" en bas d'écran
  var PILULE_FILTRE = true;
  // true = on supprime tout le bloc du haut (recherche, "Filtrer Par", tri, filtres actifs, compteur)
  var MASQUER_BARRE_HAUT = true;
  var TEXTE_PILULE = 'Filtrer';
  var PILULE_POSITION_PC = 'centre';      // 'gauche', 'centre' ou 'droite'
  var PILULE_POSITION_MOBILE = 'centre';
  var PILULE_BAS_PC = '28px';
  var PILULE_BAS_MOBILE = '20px';
  var PILULE_FOND = '#A88B79';
  var PILULE_TEXTE_COULEUR = '#ffffff';
  var PILULE_OMBRE = '0 4px 12px rgba(120, 90, 75, 0.35)';

  // ---------- Outils ----------
  function log() {
    try { console.log.apply(console, ['[commun]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
  }

  function poser(el, styles) {
    for (var k in styles) {
      if (styles.hasOwnProperty(k)) el.style.setProperty(k, styles[k], 'important');
    }
  }

  function texteNet(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  // Sur téléphone et petite tablette, la page peut être plus large que l'écran si un élément déborde :
  // on prend alors la plus petite des deux largeurs. Sur ordinateur, on garde la largeur de la fenêtre.
  function largeurEcran() {
    var w = window.innerWidth;
    var s = (window.screen && window.screen.width) ? window.screen.width : w;
    if (s <= 900) return Math.min(w, s);
    return w;
  }

  function basEntete() {
    var entete = document.querySelector('#shopify-section-header, header');
    return entete ? Math.max(0, entete.getBoundingClientRect().bottom) : 0;
  }

  function contientProduits(el) {
    return !!el.querySelector('.gammes, .gamme, .spf-product-card, ul.product-grid, #gf-products');
  }

  function injecterStyles() {
    if (document.getElementById('col-styles')) return;
    var s = document.createElement('style');
    s.id = 'col-styles';
    s.textContent =
      '.col_pilule{display:inline-flex!important;opacity:0!important;visibility:hidden!important;transform:translateY(12px)!important;transition:opacity .25s ease,transform .25s ease,visibility .25s!important}' +
      '.col_pilule.est-visible{opacity:1!important;visibility:visible!important;transform:translateY(0)!important}' +
      '.col_pilule:hover{opacity:.88!important}' +
      '.col_pilule:focus-visible{outline:2px solid #fff;outline-offset:-5px}';
    document.head.appendChild(s);
  }

  // ---------- Le bandeau des points forts ----------
  var bandeau = null;
  var derniereRechercheBandeau = 0;
  var essaisBandeau = 0;

  function trouverBandeau() {
    if (bandeau && document.body.contains(bandeau)) return bandeau;
    bandeau = null;
    if (essaisBandeau >= 40 || Date.now() - derniereRechercheBandeau < 500) return null;
    derniereRechercheBandeau = Date.now();
    essaisBandeau++;
    var els = document.querySelectorAll('p, span, a, div, li, h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = texteNet(el);
      if (t.length > 160 || t.indexOf(TEXTE_BANDEAU) === -1) continue;
      if (!el.getClientRects || el.getClientRects().length === 0) continue;
      if (el.closest('header, #shopify-section-header, .gammes, .spf-product-card, .col_pilule')) continue;
      // On remonte jusqu'à la section du bandeau, sans jamais englober de produits
      var cible = el;
      var p = el;
      while (p && p !== document.body) {
        if (contientProduits(p)) break;
        cible = p;
        if (p.classList && p.classList.contains('shopify-section')) break;
        p = p.parentElement;
      }
      bandeau = cible;
      return bandeau;
    }
    return null;
  }

  // Vrai quand le bandeau est passé au dessus de l'en-tête. Si le bandeau est introuvable, les boutons restent affichés.
  function bandeauPasse() {
    if (!CACHER_TANT_QUE_BANDEAU) return true;
    var b = trouverBandeau();
    if (!b) return true;
    return b.getBoundingClientRect().bottom <= basEntete() + MARGE_BANDEAU;
  }

  // ---------- Boutons du site : "Savoir-faire" et "Demander un échantillon" ----------
  var conteneursSite = [];
  var derniereRechercheSite = 0;
  var essaisRechercheSite = 0;
  var voileHaut = null;

  // Renvoie l'élément fixe qui porte le bouton, seulement s'il est dans la moitié basse de l'écran
  // (ce qui écarte les liens du menu, situés dans l'en-tête)
  function conteneurFixeBas(el) {
    var p = el;
    while (p && p !== document.body) {
      if (p.getAttribute && p.getAttribute('data-col-haut') === '1') return p;
      if (getComputedStyle(p).position === 'fixed') {
        var r = p.getBoundingClientRect();
        return (r.top + r.height / 2 > window.innerHeight / 2) ? p : null;
      }
      p = p.parentElement;
    }
    return null;
  }

  function chercherConteneurSite(nom) {
    var passes = ['a, button, [role="button"]', 'span, div, p'];
    for (var p = 0; p < passes.length; p++) {
      var els = document.querySelectorAll(passes[p]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (p === 1 && el.childElementCount > 2) continue;
        if (el.closest('.gammes, .col_pilule, .spf-product-card')) continue;
        if (texteNet(el) !== nom) continue;
        if (!el.getClientRects || el.getClientRects().length === 0) continue;
        var c = conteneurFixeBas(el);
        if (c) return c;
      }
    }
    return null;
  }

  function boutonsSiteComplets() {
    if (conteneursSite.length >= 2) return true;
    return conteneursSite.some(function (c) {
      var t = texteNet(c);
      return t.indexOf('savoir-faire') > -1 && t.indexOf('chantillon') > -1;
    });
  }

  function afficherBoutons(oui) {
    conteneursSite.forEach(function (c) {
      poser(c, {
        'opacity': oui ? '1' : '0',
        'visibility': oui ? 'visible' : 'hidden',
        'pointer-events': oui ? 'auto' : 'none'
      });
    });
  }

  function retirerVoile() {
    if (voileHaut && voileHaut.parentNode) voileHaut.parentNode.removeChild(voileHaut);
    voileHaut = null;
  }

  function majVoile(bas, visible) {
    if (!VOILE_HAUT) { retirerVoile(); return; }
    if (!voileHaut || !document.body.contains(voileHaut)) {
      voileHaut = document.createElement('div');
      voileHaut.className = 'col_voile_haut';
      voileHaut.setAttribute('aria-hidden', 'true');
      document.body.appendChild(voileHaut);
    }
    var hBoutons = 0;
    conteneursSite.forEach(function (c) {
      hBoutons = Math.max(hBoutons, c.getBoundingClientRect().height);
    });
    var hauteur = Math.round(BOUTONS_HAUT_ECART + hBoutons + VOILE_DEGRADE);
    var pleine = 'rgba(' + VOILE_RGB + ', ' + VOILE_OPACITE + ')';
    var apparition = VOILE_APPARITION > 0 ? Math.min(1, Math.max(0, window.scrollY / VOILE_APPARITION)) : 1;
    poser(voileHaut, {
      'display': 'block',
      'position': 'fixed',
      'top': Math.round(bas) + 'px',
      'left': '0',
      'right': '0',
      'height': 'calc(' + hauteur + 'px + env(safe-area-inset-top, 0px))',
      'z-index': '44',
      'pointer-events': 'none',
      'background': 'linear-gradient(to bottom, ' + pleine + ' 0%, ' + pleine + ' 55%, rgba(' + VOILE_RGB + ', 0) 100%)',
      'opacity': visible ? String(apparition) : '0',
      'transition': 'opacity 0.25s ease'
    });
  }

  function majBoutons() {
    if (!BOUTONS_EN_HAUT) return;

    conteneursSite = conteneursSite.filter(function (c) { return document.body.contains(c); });

    if (!boutonsSiteComplets() && essaisRechercheSite < 60 && Date.now() - derniereRechercheSite > 500) {
      derniereRechercheSite = Date.now();
      essaisRechercheSite++;
      ['savoir-faire', 'demander un échantillon'].forEach(function (nom) {
        var c = chercherConteneurSite(nom);
        if (c && conteneursSite.indexOf(c) === -1) conteneursSite.push(c);
      });
    }
    if (!conteneursSite.length) return;

    var bas = basEntete();
    conteneursSite.forEach(function (c) {
      c.setAttribute('data-col-haut', '1');
      poser(c, {
        'position': 'fixed',
        'bottom': 'auto',
        'top': 'calc(' + Math.round(bas + BOUTONS_HAUT_ECART) + 'px + env(safe-area-inset-top, 0px))',
        'z-index': '45',
        'transition': 'opacity 0.25s ease, visibility 0.25s'
      });
    });

    var oui = bandeauPasse();
    afficherBoutons(oui);
    majVoile(bas, oui);
  }

  // ---------- Barre de filtres du thème et bouton flottant ----------
  var boutonFiltre = null;
  var barreFiltre = null;
  var pilule = null;

  function estCandidatFiltre(el) {
    if (el.closest && el.closest('.col_pilule')) return false;
    if (!el.getClientRects || el.getClientRects().length === 0) return false;
    var t = texteNet(el);
    return t === 'filtrer par' || t === 'filtrer';
  }

  function trouverBoutonFiltre() {
    if (boutonFiltre && document.body.contains(boutonFiltre)) return boutonFiltre;
    boutonFiltre = null;
    var passes = ['button, a, [role="button"], summary, label', 'span, div, p'];
    for (var p = 0; p < passes.length; p++) {
      var candidats = document.querySelectorAll(passes[p]);
      for (var i = 0; i < candidats.length; i++) {
        var c = candidats[i];
        if (!estCandidatFiltre(c)) continue;
        // On ignore les éléments d'un panneau plein écran (le tiroir de filtres, par exemple)
        var parent = c;
        var trop = false;
        while (parent && parent !== document.body) {
          var pos = getComputedStyle(parent).position;
          if ((pos === 'fixed' || pos === 'sticky') && parent.getBoundingClientRect().height > window.innerHeight * 0.4) {
            trop = true;
            break;
          }
          parent = parent.parentElement;
        }
        if (trop) continue;
        boutonFiltre = c;
        return boutonFiltre;
      }
    }
    return null;
  }

  function trouverBarreFiltre(bouton) {
    if (barreFiltre && document.body.contains(barreFiltre)) return barreFiltre;
    barreFiltre = null;
    var el = bouton;
    while (el && el !== document.body) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        barreFiltre = el;
        return barreFiltre;
      }
      el = el.parentElement;
    }
    return null;
  }

  function barreParContenu(bouton) {
    var el = bouton.parentElement;
    while (el && el !== document.body) {
      if (contientProduits(el)) return null;
      if (el.querySelector('input') && el.querySelector('select')) return el;
      el = el.parentElement;
    }
    return null;
  }

  // Le panneau de filtres contient les titres de vos filtres
  function contientPanneau(el) {
    var t = texteNet(el);
    return t.indexOf('type de montage') > -1 || t.indexOf('couleur de pierre') > -1;
  }

  // Invisible et sorti de la mise en page, mais toujours présent : un clic programmé fonctionne encore
  function cacherVisuellement(el) {
    if (!el || el.getAttribute('data-col-cache') === '1') return;
    el.setAttribute('data-col-cache', '1');
    poser(el, {
      'position': 'absolute',
      'width': '1px',
      'height': '1px',
      'min-height': '0',
      'margin': '-1px',
      'padding': '0',
      'border': '0',
      'overflow': 'hidden',
      'clip': 'rect(0 0 0 0)',
      'clip-path': 'inset(50%)',
      'white-space': 'nowrap',
      'opacity': '0',
      'pointer-events': 'none'
    });
  }

  // Quand le panneau ou les produits sont dans le même bloc que la barre : on cache tout le reste et on les garde
  function masquerHors(el, bouton) {
    Array.prototype.forEach.call(el.children, function (enfant) {
      if (enfant === bouton) {
        cacherVisuellement(enfant);
      } else if (enfant.contains(bouton)) {
        masquerHors(enfant, bouton);
      } else if (contientPanneau(enfant) || contientProduits(enfant)) {
        // à garder tel quel
      } else {
        cacherVisuellement(enfant);
      }
    });
  }

  function creerIconeFiltre() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    [['M2 4.5 H14'], ['M2 11.5 H14']].forEach(function (d) {
      var p = document.createElementNS(svgNS, 'path');
      p.setAttribute('d', d[0]);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.3');
      p.setAttribute('stroke-linecap', 'round');
      svg.appendChild(p);
    });
    [[10, 4.5], [5.5, 11.5]].forEach(function (c) {
      var k = document.createElementNS(svgNS, 'circle');
      k.setAttribute('cx', String(c[0]));
      k.setAttribute('cy', String(c[1]));
      k.setAttribute('r', '1.7');
      k.setAttribute('fill', PILULE_FOND);
      k.setAttribute('stroke', 'currentColor');
      k.setAttribute('stroke-width', '1.3');
      svg.appendChild(k);
    });
    return svg;
  }

  function creerPilule() {
    if (pilule) return pilule;
    pilule = document.createElement('button');
    pilule.type = 'button';
    pilule.className = 'col_pilule';
    pilule.setAttribute('aria-label', TEXTE_PILULE);
    pilule.appendChild(creerIconeFiltre());
    var t = document.createElement('span');
    t.textContent = TEXTE_PILULE;
    pilule.appendChild(t);
    pilule.addEventListener('click', function () {
      var b = trouverBoutonFiltre();
      if (b) b.click();
    });
    document.body.appendChild(pilule);
    return pilule;
  }

  function placerPilule() {
    if (!pilule) return;
    var mobile = largeurEcran() < 750;
    var pos = mobile ? PILULE_POSITION_MOBILE : PILULE_POSITION_PC;
    var bas = mobile ? PILULE_BAS_MOBILE : PILULE_BAS_PC;
    var st = {
      'position': 'fixed',
      'z-index': '50',
      'bottom': 'calc(' + bas + ' + env(safe-area-inset-bottom, 0px))',
      'left': 'auto',
      'right': 'auto',
      'margin': '0',
      'width': 'max-content',
      'align-items': 'center',
      'gap': '10px',
      'padding': mobile ? '14px 24px' : '15px 28px',
      'border': '0',
      'border-radius': '999px',
      'background-color': PILULE_FOND,
      'background-image': 'none',
      'color': PILULE_TEXTE_COULEUR,
      '-webkit-text-fill-color': PILULE_TEXTE_COULEUR,
      'font-family': 'inherit',
      'font-size': '15px',
      'font-weight': '500',
      'letter-spacing': '0.05em',
      'line-height': '1',
      'text-transform': 'none',
      'box-shadow': PILULE_OMBRE,
      'cursor': 'pointer'
    };
    if (pos === 'gauche') {
      st['left'] = '24px';
    } else if (pos === 'droite') {
      st['right'] = '24px';
    } else {
      st['left'] = '0';
      st['right'] = '0';
      st['margin-left'] = 'auto';
      st['margin-right'] = 'auto';
    }
    poser(pilule, st);
  }

  function zoneProduits() {
    return document.querySelector('.gammes') ||
      document.querySelector('.product-grid-container') ||
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('ul.product-grid');
  }

  // Vrai tant que la grille de produits est à l'écran ET que sa fin n'est pas passée au dessus du bouton
  function grilleVisible() {
    var z = zoneProduits();
    if (!z) return true;
    var r = z.getBoundingClientRect();
    var actions = document.querySelectorAll('.gamme_actions');
    var fin = actions.length ? actions[actions.length - 1].getBoundingClientRect().bottom : r.bottom;
    var hautBouton = pilule ? pilule.getBoundingClientRect().top : window.innerHeight - 100;
    return fin > hautBouton && r.top < window.innerHeight - 80;
  }

  function majPilule() {
    if (!pilule) return;
    if (grilleVisible()) {
      pilule.classList.add('est-visible');
    } else {
      pilule.classList.remove('est-visible');
    }
  }

  function majBarre() {
    if (!PILULE_FILTRE) return;
    var bouton = trouverBoutonFiltre();
    if (!bouton) return;
    var barre = trouverBarreFiltre(bouton);

    if (MASQUER_BARRE_HAUT) {
      if (!barre) barre = barreParContenu(bouton);
      if (!barre) {
        cacherVisuellement(bouton);
      } else if (!contientPanneau(barre) && !contientProduits(barre)) {
        cacherVisuellement(barre);
      } else {
        masquerHors(barre, bouton);
      }
    }

    creerPilule();
    placerPilule();
    majPilule();
  }

  // ---------- Mise à jour ----------
  function majTout() {
    majBarre();
    majBoutons();
  }

  var scrollEnAttente = false;
  var derniereMajLourde = 0;

  // Pendant le défilement : calculs légers à chaque image, recherche des éléments au plus une fois par seconde
  function surDefilement() {
    if (scrollEnAttente) return;
    scrollEnAttente = true;
    window.requestAnimationFrame(function () {
      scrollEnAttente = false;
      majBoutons();
      majPilule();
      var maintenant = Date.now();
      if (maintenant - derniereMajLourde > 1000) {
        derniereMajLourde = maintenant;
        majBarre();
      }
    });
  }

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(majTout, 200);
  }

  function demarrer() {
    injecterStyles();
    majTout();

    window.addEventListener('scroll', surDefilement, { passive: true });
    window.addEventListener('resize', function () { placerPilule(); majTout(); });
    window.addEventListener('orientationchange', function () { setTimeout(majTout, 250); });
    window.addEventListener('load', majTout);
    window.addEventListener('globoFilterRenderCompleted', function () { setTimeout(majTout, 150); });

    try {
      new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true });
    } catch (e) { log('observateur indisponible', e); }

    var essais = 0;
    var sonde = setInterval(function () {
      majTout();
      essais++;
      if (essais >= 15) clearInterval(sonde);
    }, 1000);

    setTimeout(function () {
      log('bandeau : ' + (bandeau ? 'trouvé' : 'introuvable') +
        ' | boutons du site : ' + conteneursSite.length +
        ' | bouton Filtrer : ' + (boutonFiltre ? 'trouvé' : 'introuvable'));
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();